exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option-group[data-v-bf5f2156]{margin-left:5px}.option-group .form-group[data-v-bf5f2156]{padding-left:0}.option-group .option-label[data-v-bf5f2156]{margin-bottom:0}.option-group .col-md-7[data-v-bf5f2156]{width:90%}a[data-v-bf5f2156]:hover{background-color:#fff!important;color:#000!important}.close-icon[data-v-bf5f2156]{color:#000!important;position:absolute;right:10px;top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bf5f2156","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/_modules/Dashboard/widgets/SharedComponents/WidgetOptions.vue
// module id = qeFE
// module chunks = 12